import PropTypes from "prop-types";
import { CgFileDocument } from "react-icons/cg";

const DocumentIcon = ({ size, className, onClick, title }) => {
  return (
    <CgFileDocument
      className={`no-shrink  ${className}`}
      size={size}
      title={title}
      onClick={onClick}
    />
  );
};

DocumentIcon.defaultProps = {
  size: 30,
  className: "",
  onClick: () => {},
  title: "",
};

DocumentIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default DocumentIcon;
